export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#filtering-sorting","viewBox":"0 0 24 24"}